import {
  Box,
  Button,
  Grid,
  Pagination,
  Stack,
  Typography,
} from "@mui/material";
import StockCard from "./stockCard";
import DownloadIcon from "@mui/icons-material/Download";

import {
  getInventoryData,
  getStockDetail,
  getStockDetailXLSX,
} from "./stockApi";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import { useEffect } from "react";
import { useState } from "react";
import { getData } from "./stockCustomApiHandler";
import TableComponent from "./table";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { EditStockModal } from "./editStockModal";
import { ReducePop } from "./reducerlist";
import TableReport from "./tableReport";
import axios from "axios";
import { useNavigate } from "react-router";
import { ArrowBackIcon } from "../../common/icon";

const InventoryT = ({ gridSize }) => {
  const [data, setData] = useState();
  const [stocks, setStocks] = useState();
  const stockPayload = {
    page: 1,
    pageSize: 100,
  };
 const navigate = useNavigate();

  const [open_t, setOpen_t] = useState(false);

  const [open, setOpen] = useState(false);

  const [pagination, setPagination] = useState({
    page: 1,
    total: 1,
    records: 0,
  });

  const handleChange = (event, value) => {
    getData({ ...stockPayload, page: value });
    setPagination({
      ...pagination,
      page: value,
    });
  };

  useEffect(() => {
    getData(
      stockPayload,
      getInventoryData,
      setStocks,
      setPagination,
      pagination
    );
  }, []);

  const downloadXLSXFile = async (param) => {
    try {
      // const response = await axios.post(
      //   "user/api/v1/CounterSales/GetOverAllCounterSalesDetailsXlsx",
      //   param,
      //   {
      //     responseType: "blob",
      //   }
      // );

      const response = await getStockDetailXLSX(param, {
        responseType: "blob",
      });

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading XLSX file:", error);
    }
  };

  return (
    <Box sx={{ p: "17px 30px", background: "#ede9ff", minHeight: "100vh" }}>
      <Grid container alignItems="center">
        <Grid container alignItems="center" spacing={2}>
          {/* Back Icon */}
          <Grid item>
            <ArrowBackIcon
              sx={{ cursor: "pointer" }}
              onClick={() => navigate("/home")}
            />
          </Grid>
          <Grid item xs>
            <Box
              sx={{
                background:
                  "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
                padding: "10px",
                paddingLeft: "20px",
                borderRadius: 2,
                color: "#01008B", // optional text color
                textAlign: "left",
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 500,
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontSize: { xs: "12px", sm: "13px", md: "18px" },
                }}
              >
                {" "}
                Inventory Report{" "}
              </Typography>
            </Box>
          </Grid>
        </Grid>
        {/* Date Input */}

        <Grid
          container
          sx={{ paddingBottom: "20px", paddingTop: "20px", gap: 1 }}
        >
          <Grid
            item
            xs={7}
            sm={8}
            md={8}
            lg={9}
            sx={
              {
                // gap: ,
                //  padding:"0px"
              }
            }
          >
            <Box
              item
              sx={{
                padding: "8px",
                // margin: "8px 8px 0px 0",
                fontWeight: "500",
                // width:"100px",
                width: "150px",
                backgroundColor: "#CCCCFF",
                fontSize: { xs: "12px", sm: "13px", md: "18px" },
                borderRadius: "8px",
              }}
            >
              <Typography
                color="primary"
                textAlign={"center"}
                sx={{
                  fontFamily: "'Montserrat', sans-serif",
                  fontSize: { xs: "12px", sm: "13px", md: "18px" },
                  fontWeight: 500,
                }}
              >
                Total Items :{" "}
                <span
                  style={{
                    fontWeight: "700",
                  }}
                >
                  {" "}
                  {pagination.records}
                </span>
              </Typography>
            </Box>
            {/* Download Button */}
          </Grid>

          {/* Download Button */}
          <Grid
            item
            md={3}
            lg={2}
            sm={3}
            xs={4}
            sx={{
              padding: "0px",
            }}
          >
            <Button
              variant="contained"
              fullWidth
              onClick={() =>
                downloadXLSXFile({
                  ...stockPayload,
                })
              }
              sx={{
                height: "40px",
                backgroundColor: "#14008B",
                fontSize: { xs: "12px", sm: "13px", md: "18px" },
                padding: "0px",
              }}
              endIcon={<DownloadIcon />}
            >
              Download
            </Button>
          </Grid>
        </Grid>

        {/* Total Sale */}
      </Grid>
      <Grid
        container
        sx={
          {
            // p: "20px",
            // display: "flex",
          }
        }
        // spacing={2}
      >
        <Grid xs={12}>
          <TableReport
            salesData={[]}
            colName={[
              {
                title: "Category",
                attribute: {
                  xs: 3,
                },
              },
              {
                title: "Items",
                attribute: {
                  xs: 3,
                },
              },
              {
                title: "Amount",
                attribute: {
                  xs: 3,
                },
              },
              {
                title: "Category",
                attribute: {
                  xs: 3,
                },
              },
            ]}
            setModalData={setData}
            setOpen={setOpen_t}
            data={stocks ?? []}
          />
        </Grid>

        {/* <Grid xs={12} sx={{ display: "flex", justifyContent: "center" }}>


          <Typography
            color="primary"
            sx={{ display: "flex", alignItems: "center" }}
          >
            <strong>Total Items: &nbsp;</strong>
            <strong> {pagination.records}&nbsp;</strong>
          </Typography>
          <Pagination
            count={pagination.total}
            page={pagination.page}
            onChange={handleChange}
          />
        </Grid> */}

        {/* <Grid xs={12} sx={{ textAlign: "right" }}>
          {gridSize && (
            <FileDownloadIcon
              sx={{
                ml: "10px",
                mr: "0px",
                height: "1.4375em",
                cursor: "pointer",
                // m: "16.5px 14px",
              }}
            />
          )}
        </Grid>
        <Grid
          item
          container
          spacing={2}
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "80vh",
          }}
        >
          <TableComponent
            stocks={stocks}
            setModalData={setData}
            setOpen={setOpen_t}
          />
        </Grid> */}

        {/* <Grid container sx={{ pt: "10px" }}>
        <Grid item xs={4}>
          <Typography
            color="primary"
            sx={{ display: "flex", alignItems: "center" }}
          >
            <strong>Total Items: &nbsp;</strong>
            <strong> {pagination.records}&nbsp;</strong>
          </Typography>
        </Grid>
        <Grid
          item
          xs={4}
          sx={{
            // bgcolor: "red",
            display: "flex",
            justifyContent: "center",
          }}
        >
        
        </Grid>
        <Grid item xs={4}></Grid>
      </Grid> */}
        <ReducePop
          open={open_t}
          setOpen={setOpen_t}
          data={data}
          setData={setData}
          next={setOpen}
        />
        <EditStockModal
          open={open}
          setOpen={setOpen}
          data={data}
          setData={setData}
        />
      </Grid>
    </Box>
  );
};

export default InventoryT;
